import React from 'react';
import type { CaTaxImplicationsResult } from '@capintel/instruments-lib';

import CurrencyCell from '@/views/components/cells/CurrencyCell';
import FormattedMessageV2 from '@/views/components/i18n/FormattedMessageV2';
import type { Row } from '../TaxAnalysisImplicationsSections';

export function getCaImplicationsRows(): Row<CaTaxImplicationsResult>[] {
  return [
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.RealizedGains" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.RealizedGains',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.realizedGains;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.RealizedLosses" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.RealizedLosses',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.realizedLosses;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.CapitalGainLossNet" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.CapitalGainLossNet',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.capitalGainLossNet;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.TaxableCapitalGains" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.TaxableCapitalGains',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.taxableCapitalGains;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.TaxableGainsNetOfCarryforward" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.TaxableGainsNetOfCarryforward',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.taxableGainsNetOfCarryforward;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.TotalEstimatedTaxes" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.TotalEstimatedTaxes',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.totalEstimatedTaxes;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
    {
      label: <FormattedMessageV2 className="label-header" toLocalize="Comparison.TaxAnalysis.ImplicationsTable.CA.CarryforwardBalance" />,
      key: 'Comparison.TaxAnalysis.ImplicationsTable.CA.CarryforwardBalance',
      cell: ({ taxAnalysisData }) => {
        const value = taxAnalysisData?.carryforwardBalance;
        return value == null ? '-' : <CurrencyCell value={{ value }} />;
      },
    },
  ];
}
